import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/site'
    },
    {
      path: '/site',
      name: 'SiteDetail',
      component: Home,
      props: (route) => ({
        siteId: parseInt(route.params.id, 10)
      }),
      children: [
        {
          path: '/site/:id',
          component: () => import(/* webpackChunkName: "site" */ './views/SiteDetail/index.vue'),
          props: (route) => ({
            siteId: parseInt(route.params.id, 10)
          })
        }
      ]
    },
    {
      path: '/js-sdk',
      name: 'JsSdk',
      component: () => import(/* webpackChunkName: "js-sdk" */ './views/JsSdk/index.vue')
    },
    {
      path: '/permission-manage',
      name: 'permissionManage',
      redirect: '/permission-manage/white-user'
    },
    {
      path: '/permission-manage/:channel',
      name: 'PermissionManageChannel',
      props: (route) => ({
        channel: route.params.channel
      }),
      component: () => import(/* webpackChunkName: "permission-manage" */ './views/PermissionManage/index.vue')
    }
  ]
})
